
import request from './config'

// 合作厂商模块接口

// 获取首页游戏列表
export function getHomePartnerGame() {
  return request({
    url: '/front/home/partner/game',
  })
}
// 获取游戏分类及分类下游戏
export function getPartnerGame() {
  return request({
    url: '/front/partner/game',
  })
}

// 获取指定位置Banner
export function getBanner(params) {
  return request({
    url: '/front/partner/banner',
    params
  })
}


